import { type LocaleName } from '@solinkcorp/locale';

export default class I18nError extends Error {
  readonly i18nMessage: (localeCode: LocaleName) => string;

  constructor(message: string, i18nMessage: (localeCode: LocaleName) => string) {
    super(message);

    this.i18nMessage = i18nMessage;
    // Set the prototype explicitly.
    Object.setPrototypeOf(this, I18nError.prototype);
  }
}
